

import * as api from "../../../../api"; 


  
export const AWSFilePresignedURL = (APIData) => async (dispatch)=>{


    
    try {
        
        const {data } = await api.AWSFilePresignedURL(APIData);
          
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const createNewLessonForCourseByAdmin = (APIData) => async (dispatch)=>{


    
    try {
        
        const {data } = await api.createNewLessonForCourseByAdmin(APIData);
          
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}



export const getAllFilesBys3Key = (APIData) => async (dispatch)=>{


    
    try {
        
        const {data } = await api?.getAllFilesBys3Key(APIData);
          
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}